export const WorkWithUsActions = {
  GET_WORK_WITH_US: "GET_WORK_WITH_US",
  SET_WORK_WITH_US: "SET_WORK_WITH_US",
};
